import { useRef, useState } from 'react'
import Slider, { Settings } from 'react-slick'
import { InfoCard } from 'component-library'
import { useSetSlideLinkTabIndex } from 'shared-utilities'
import { withPrefix } from 'gatsby'
import LinkComponent from '../LinkComponent/LinkComponent'
import './RelatedCarousel.scss'

const related_placeholder =
  'https://assets.cloud.pennylane.ai/datasets/generic/thumbnail/pennylane-datasets-thumbnail-generic.png'

export interface IRelatedCarouselCard {
  link: string
  label: string
  image: string
}

interface IRelatedCarouselProps {
  title?: string
  showCarousel?: boolean
  relatedItems?: IRelatedCarouselCard[]
}

const RelatedCarouselSlide = ({
  showCarousel,
  item,
  addMutationObserver,
}: {
  showCarousel: boolean
  item: IRelatedCarouselCard
  addMutationObserver: boolean
}) => {
  const cardRef = useRef(null)
  const [isVisible, toggleIsVisible] = useState<boolean>(!addMutationObserver)
  useSetSlideLinkTabIndex(cardRef, toggleIsVisible, addMutationObserver)

  const formattedImage = () => {
    if (item.image) {
      return item.image.includes('https://')
        ? item.image
        : withPrefix(item.image)
    } else {
      return related_placeholder
    }
  }

  return (
    <div
      ref={cardRef}
      className={`RelatedItemCard ${!showCarousel ? 'mb-4' : ''}`}
      data-testid="item-card"
    >
      <LinkComponent href={item.link} tabIndex={isVisible ? 0 : -1}>
        <InfoCard
          label={item.label}
          image={formattedImage()}
          className="RelatedItemCard"
        />
      </LinkComponent>
    </div>
  )
}

const RelatedCarousel = ({
  relatedItems,
  title,
  showCarousel = true,
}: IRelatedCarouselProps) => {
  const slickSettings: Settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const related = relatedItems?.map((item, index) => {
    return (
      <RelatedCarouselSlide
        key={index}
        showCarousel
        item={item}
        addMutationObserver={relatedItems.length > 3 && showCarousel}
      />
    )
  })

  return (
    <section className="RelatedCarousel">
      <div>
        {title && <h2 className="tw-my-10 text-center">{title}</h2>}
        {relatedItems && relatedItems?.length > 3 && showCarousel ? (
          <div className="RelatedCarousel__Container">
            <div className="my-10">
              <Slider {...slickSettings}>{related}</Slider>
            </div>
          </div>
        ) : (
          <div className="RelatedItems__container">{related}</div>
        )}
      </div>
    </section>
  )
}

export default RelatedCarousel
